import { format, parseISO } from 'date-fns';
import StockStatusData, { StockStatus } from '../../domain/StockStatusData';

// DTO que llega de backend
export interface StockStatusDTO {
  quantity: number;
  date: string; // ISO: '2026-06-03T03:49:12Z'
  hour: string;
}

export class StockStatusMapper {
  static fromDTO(data: StockStatusDTO[]): StockStatusData {
    const formatted: StockStatus[] = data.map((item) => {
      const parsedDate = parseISO(item.date);

      return {
        quantity: item.quantity,
        date: format(parsedDate, 'dd/MM/yyyy'),
        hour: item.hour.slice(0, 5)
      };
    });

    return new StockStatusData(formatted);
  }
}
